import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Zt from "./base-device-parser.js";
import { Browsers as ri, OperatingSystems as ot } from "./device-constants.js";

var ni = /*#__PURE__*/function (_Zt) {
  _inherits(ni, _Zt);

  var _super = _createSuper(ni);

  function ni() {
    var _this;

    _classCallCheck(this, ni);

    _this = _super.call(this), _this.du = ni.gu(navigator.userAgent || "");
    return _this;
  }

  _createClass(ni, [{
    key: "tf",
    value: function tf() {
      return this.du[0] || "Unknown Browser";
    }
  }, {
    key: "ef",
    value: function ef() {
      return this.du[1] || "Unknown Version";
    }
  }, {
    key: "Ko",
    value: function Ko(r) {
      for (var e = 0; e < r.length; e++) {
        var n = r[e].string,
            i = ni.rf(n, r[e]);
        if (i) return i === ot.kg && navigator.maxTouchPoints > 1 && (i = ot.ln), Promise.resolve(i);
      }

      return Promise.resolve(navigator.platform);
    }
  }], [{
    key: "gu",
    value: function gu(r) {
      var e,
          n = r.match(/(samsungbrowser|tizen|roku|konqueror|icab|crios|opera|ucbrowser|chrome|safari|firefox|camino|msie|trident(?=\/))\/?\s*(\.?\d+(\.\d+)*)/i) || [];
      if (/trident/i.test(n[1])) return e = /\brv[ :]+(\.?\d+(\.\d+)*)/g.exec(r) || [], [ri.yg, e[1] || ""];
      if (-1 !== r.indexOf("(Web0S; Linux/SmartTV)")) return ["LG Smart TV", null];
      if (-1 !== r.indexOf("CrKey")) return ["Chromecast", null];
      if (-1 !== r.indexOf("BRAVIA") || -1 !== r.indexOf("SonyCEBrowser") || -1 !== r.indexOf("SonyDTV")) return ["Sony Smart TV", null];
      if (-1 !== r.indexOf("PhilipsTV")) return ["Philips Smart TV", null];
      if (r.match(/\b(Roku)\b/)) return ["Roku", null];
      if (r.match(/\bAFTM\b/)) return ["Amazon Fire Stick", null];
      if (n[1] === ri.rE && (e = r.match(/\b(OPR|Edge|EdgA|Edg|UCBrowser)\/(\.?\d+(\.\d+)*)/), null != e)) return e = e.slice(1), e[0] = e[0].replace("OPR", ri.EE), e[0] = e[0].replace("EdgA", ri.eE), "Edg" === e[0] && (e[0] = ri.eE), [e[0], e[1]];
      if (n[1] === ri.Bg && (e = r.match(/\b(EdgiOS)\/(\.?\d+(\.\d+)*)/), null != e)) return e = e.slice(1), e[0] = e[0].replace("EdgiOS", ri.eE), [e[0], e[1]];
      if (n = n[2] ? [n[1], n[2]] : [null, null], n[0] === ri.Bg && null != (e = r.match(/version\/(\.?\d+(\.\d+)*)/i)) && n.splice(1, 1, e[1]), null != (e = r.match(/\b(UCBrowser)\/(\.?\d+(\.\d+)*)/)) && n.splice(1, 1, e[2]), n[0] === ri.EE && null != (e = r.match(/mini\/(\.?\d+(\.\d+)*)/i))) return ["Opera Mini", e[1] || ""];

      if (n[0]) {
        var _r = n[0].toLowerCase();

        "msie" === _r && (n[0] = ri.yg), "crios" === _r && (n[0] = ri.rE), "tizen" === _r && (n[0] = "Samsung Smart TV", n[1] = null), "samsungbrowser" === _r && (n[0] = "Samsung Browser");
      }

      return n;
    }
  }]);

  return ni;
}(Zt);

export { ni as default };